
const PATH = {
    PARURL:'http://18.224.72.250/api/gateWay/pubCtrl.do',
    // PARURL:'http://192.168.0.30:8080/api/gateWay/pubCtrl.do',//蒋涛
}



export {
    PATH,
}